export { default as EmployeeGoalForm } from './EmployeeGoalForm/EmployeeGoalForm';
export { default as EmployeeGoalsTable } from './EmployeeGoalsTable/EmployeeGoalsTable';
